/**
 * Movimiento de la hoja del TELÉFONO, en un solo sitio.
 *
 * La aplicación tenía dos sistemas de hojas con tiempos distintos sin que nadie lo
 * hubiera decidido: las de Radix se animan por CSS (260 ms al abrir, 200 al cerrar,
 * en `index.css`) y las de framer-motion —el conmutador de voz y la hoja de los
 * pasos— llevaban `duration: 0.5` escrito a mano. Medio segundo es casi el DOBLE que
 * el resto, y encima con `easeInOut`, que arranca despacio: en un teléfono justo de
 * potencia eso no se lee como «lento», se lee como «no responde». Era exactamente la
 * hoja que costaba abrir.
 *
 * 280 ms con una curva que sale rápido y frena al final es lo que hacen las hojas
 * nativas (la de comentarios de YouTube, la referencia de la que venimos hablando).
 * El aspecto no cambia: es el mismo recorrido, sin la espera de más.
 */
/**
 * CUÁNTO DURA UNA HOJA, EN UN SOLO SITIO (29-08-2026).
 *
 * Estos números estaban escritos en CUATRO archivos que no coincidían:
 * `sheetChrome.tsx` declaraba 500 ms, `index.css` los pisaba con 260,
 * `sheetMotion.ts` decía 280 y `AnalyticsCard` llevaba 300 a mano. Ninguno
 * estaba «mal» —cada uno describía su propio motor— pero quien escribiera una
 * espera nueva («enseña el esqueleto mientras sube») tenía que adivinar cuál de
 * los cuatro era el bueno, y con 500 se quedaría esperando el doble de lo que
 * dura la animación, con la hoja en gris y todo listo detrás.
 *
 * Ahora el número vive aquí y los demás lo leen. Lo que se ve NO cambia: son los
 * mismos tiempos que ya se veían, dichos una sola vez.
 *
 * Las hojas de Radix las anima el CSS (`index.css`, regla de `[role="dialog"]`
 * fuera de `@layer` para ganarle a la utilidad de Tailwind). Las de
 * framer-motion tardan 20 ms más a propósito: la curva es distinta y así las dos
 * llegan a la vista a la vez.
 */
export const SHEET_RISE_MS = 260;
export const SHEET_PHONE_RISE_MS = 280;
export const SHEET_FALL_MS = 200;

export const SHEET_PHONE_RISE = {
  duration: SHEET_PHONE_RISE_MS / 1000,
  ease: [0.22, 1, 0.36, 1],
} as const;
export const SHEET_PHONE_FALL = {
  duration: SHEET_FALL_MS / 1000,
  ease: [0.4, 0, 1, 1],
} as const;

/** Sin movimiento: para quien pide «reducir movimiento» en el sistema. */
export const SHEET_INSTANT = { duration: 0 } as const;
